/**
 * 事件发射器 Hook
 * 提供事件监听、触发等功能
 */

(function (window) {
  function useDebounce(fn, delay, options = {}) {
    const { leading = false, trailing = true } = options;

    let timer = null;
    let lastArgs = null;
    let lastThis = null;

    function invoke() {
      fn.apply(lastThis, lastArgs);
      lastArgs = lastThis = null;
    }

    function debounced(...args) {
      lastArgs = args;
      lastThis = this;

      const shouldCallNow = leading && !timer;

      clearTimeout(timer);

      timer = setTimeout(() => {
        timer = null;
        if (trailing && !shouldCallNow) {
          invoke();
        }
      }, delay);

      if (shouldCallNow) {
        invoke();
      }
    }

    debounced.cancel = () => {
      clearTimeout(timer);
      timer = null;
      lastArgs = lastThis = null;
    };

    debounced.flush = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
        invoke();
      }
    };

    return debounced;
  }

  window.useDebounce = useDebounce;
})(window);
